import React, { useState } from "react";

import { Coordinates } from "models";

import { Button, Icon, MapBoundaryCompare, Modal } from "components";

// Same colors as the boundary maps of the farmer doc-scan review, so platform and document mean the same everywhere.
export const PLATFORM_BOUNDARY_COLOR = "#1A73E8";
export const DOCUMENT_BOUNDARY_COLOR = "#FF8C00";

type FieldBoundaryPreviewProps = {
  platformShape: Coordinates[] | null;
  documentShapes: Coordinates[][];
  title: string;
  platformLabel: string;
  documentLabel: string;
  expandLabel: string;
  closeLabel: string;
};

/** A map of the platform field against the document parcels, which opens a larger map to zoom and pan. */
export const FieldBoundaryPreview = ({
  platformShape,
  documentShapes,
  title,
  platformLabel,
  documentLabel,
  expandLabel,
  closeLabel,
}: FieldBoundaryPreviewProps) => {
  const [isMapOpen, setIsMapOpen] = useState(false);

  const legend = (
    <div className="field-boundary-legend">
      <span className="field-boundary-legend-item">
        <span className="field-boundary-legend-line field-boundary-legend-line-platform" />
        {platformLabel}
      </span>
      {documentShapes.length > 0 && (
        <span className="field-boundary-legend-item">
          <span className="field-boundary-legend-line field-boundary-legend-line-document" />
          {documentLabel}
        </span>
      )}
    </div>
  );

  return (
    <div className="field-boundary-preview">
      <MapBoundaryCompare
        primaryGeometry={platformShape}
        secondaryGeometries={documentShapes}
        primaryColor={PLATFORM_BOUNDARY_COLOR}
        secondaryColor={DOCUMENT_BOUNDARY_COLOR}
        boundsPadding={16}
        primaryWeight={1}
        dashWeight={2}
        dashScale={3}
      />
      <button type="button" className="field-boundary-preview-expand" aria-label={expandLabel} onClick={() => setIsMapOpen(true)}>
        <Icon iconName="tabler/arrows-maximize" size="s" color="#fff" />
      </button>
      <div className="field-boundary-preview-legend">{legend}</div>
      <Modal
        destroyOnClose
        maskClosable
        showModal={isMapOpen}
        onCancel={() => setIsMapOpen(false)}
        closeIcon={<Icon iconName="tabler/x" />}
        title={title}
        wrapClassName="field-boundary-modal-wrap"
        footer={
          <Button type="primary" className="field-boundary-modal-close" onClick={() => setIsMapOpen(false)}>
            {closeLabel}
          </Button>
        }
        content={
          <div className="field-boundary-modal">
            <div className="field-boundary-modal-map">
              <MapBoundaryCompare
                primaryGeometry={platformShape}
                secondaryGeometries={documentShapes}
                primaryColor={PLATFORM_BOUNDARY_COLOR}
                secondaryColor={DOCUMENT_BOUNDARY_COLOR}
                zoomable
                pannable
                boundsPadding={24}
              />
            </div>
            {legend}
          </div>
        }
      />
    </div>
  );
};
